module.exports = __webpack_public_path__ + "static/luna-dccca810e6476ec0b440fac804a469f2.jpg";